import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import Link from "next/link";
import type React from "react";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { SurveySetting } from "~/components/specifics/vendors/settings/surveys/index/SurveySetting";
import { PATH } from "~/pages/vendors/settings";
import SettingStyles from "../../SettingStyle.module.scss";

export const Page: React.FC = () => (
	<VendorLayoutV2>
		<VendorSettingLayout>
			<div className={SettingStyles.SpBreadcrumbsWrapper}>
				<Breadcrumbs
					items={[
						{ as: Link, href: PATH, label: "設定一覧" },
						{ label: "アンケート設定" }
					]}
				/>
			</div>
			<Panel>
				<PanelHeader title="アンケート設定" />
				<PanelBody>
					<SurveySetting />
				</PanelBody>
			</Panel>
		</VendorSettingLayout>
	</VendorLayoutV2>
);
